import { Column } from '../../../lib/ng-crud-table';
import { Validators } from '../../../lib/common';
import {
  AUDIODELAYDATA,
  CONNDROPDATA,
  CUSTOMREPORTS_GROUP,
  CUSTOMREPORTS_NOTGROUP,
  DNSDATA,
  EMAILDATA,
  EMAILSERVER,
  EModule,
  EMUDATA,
  FAXDATA,

  WvFilter,
  WvFiltersCommonCol,
  WvFiltersMainCol,
  WvFiltersExtraCol,

  FTPDATA,
  GENERALINFO,
  GRAPHRSLTVIEW_GROUP,
  GRAPHRSLTVIEW_NOTGROUP,
  GROUPS_CUSTOMREPORTS,
  HTTPDATA,
  NWSTAT_EMU,
  NWSTAT_FILEMONITOR,
  NWSTAT_FM_CENTRALIPS,
  NWSTAT_MOBILE,
  NWSTAT_VAC,
  NWSTAT_VQT,
  NWSTAT_VQT_CENTRALIPS,
  NWSTAT_VQUAD,
  NWSTAT_VQUAD_BT_FXO,
  NWSTAT_VQUAD_CENTRALIPS,
  NWSTAT_VQUAD_SCRIPTS,
  NWSTAT_VQUAD_SCRPARAMS,
  PAIREDBT,
  PRIVILEGES,
  PRIVILEGES_CRITERIA,
  PRIVILEGES_FILTERS,
  PRIVILEGES_RESTRICTED,
  PRIVILEGES_VQUAD_AR,
  ROUTEDATA,
  SCHEDULER,
  SCHEDULER_EMAILANDSMS,
  SCHEDULER_RECURRENCE,
  SIMINFO,
  SMSDATA,
  TCPDATA,
  UDPDATA,
  UEINFO,
  VACDATA,
  VOIPDATA,
  VQTPESQDATA,  
  VQTPOLQADATA,
  VQUADDATA,
  headersNTypes
 } from '../shared/models';
import { ColumnBase } from 'lib/ng-data-table/base';
import { GMaps } from './models/Configuration/GMaps/GMaps';
import { Filters } from './models/Filters/Filters';

export function getColumnsPlayers(): Column[] {
  const columnsPlayers: Column[] = [
    {
      title: 'Id',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'id',
      sortable: true,
      filter: true,
      frozen: true,
      width: 100,
      formHidden: true,
      type: 'number',
    },
    {
      title: 'Name',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'name',
      sortable: true,
      filter: true,
      frozen: true,
      width: 200,
      validatorFunc: Validators.get({required: true, minLength: 2, pattern: '^[a-zA-Z ]+$'}),
    },
    {
      title: 'Race',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'race',
      sortable: true,
      filter: true,
      type: 'select',
      options: [
        {id: 'ASMODIANS', name: 'ASMODIANS'},
        {id: 'ELYOS', name: 'ELYOS'},
      ],
      validatorFunc: Validators.get({required: true}),
    },
    {
      title: 'Cascading Select',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'note',
      type: 'select-dropdown',
      options: [
        {id: 'ASM1', name: 'ASM note 1', parentId: 'ASMODIANS'},
        {id: 'ASM2', name: 'ASM note 2', parentId: 'ASMODIANS'},
        {id: 'ASM3', name: 'ASM note 3', parentId: 'ASMODIANS'},
        {id: 'ASM4', name: 'ASM note 4', parentId: 'ASMODIANS'},
        {id: 'ELY1', name: 'ELY note 1', parentId: 'ELYOS'},
        {id: 'ELY2', name: 'ELY note 2', parentId: 'ELYOS'},
        {id: 'ELY3', name: 'ELY note 3', parentId: 'ELYOS'},
      ],
      dependsColumn: 'race',
      multiSelectFilter: true,
    },
    {
      title: 'Gender',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'gender',
      sortable: true,
      filter: true,
      type: 'radio',
      options: [
        {id: 'MALE', name: 'MALE'},
        {id: 'FEMALE', name: 'FEMALE'},
      ],
    },
    {
      title: 'Exp',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'exp',
      sortable: true,
      filter: true,
      type: 'number',
      validatorFunc: Validators.get({required: true, maxLength: 10, pattern: '^[0-9]+$'}),
    },
    {
      title: 'Last online',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'last_online',
      sortable: true,
      filter: true,
      type: 'datetime-local',
    },
    {
      title: 'Account name',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'account_name',
      type: 'select-popup',
      optionsUrl: 'assets/ng-crud-table/accounts.json',
      keyColumn: 'account_id',
    },
    {
      title: 'Account id',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'account_id'},
{
  title: 'Player class',
    titleBgColor: '#1976D2',
      titleColor: 'white', name: 'player_class'},
    {
      title: 'Online',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'online',
      type: 'checkbox',
      options: [
        {id: 1, name: 'Online'}
      ]
    },
    {
      title: 'Cube size',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'cube_size', type: 'number'},
    {
      title: 'Broker Kinah',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'brokerKinah'},
    {
      title: 'Bind point',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'bind_point'},
    {
      title: 'X',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'x'},
    {
      title: 'Y',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'y'},
    {
      title: 'Z',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'z'},
    {
      title: 'Recoverexp',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'recoverexp'},
    {
      title: 'Heading',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'heading'},
    {
      title: 'World id',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'world_id'},
    {
      title: 'Creation date',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'creation_date', type: 'datetime-local'},
    {
      title: 'Stigma slot size',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'advanced_stigma_slot_size'},
    {
      title: 'Warehouse size',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'warehouse_size'},
    {
      title: 'Mailbox Letters',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'mailboxLetters'},
    {
      title: 'Mailbox Unread',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'mailboxUnReadLetters'},
    {
      title: 'Title id',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'title_id'},
    {
      title: 'Repletion state',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'repletionstate'},
    {
      title: 'Rebirth id',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'rebirth_id'},
    {
      title: 'Member points',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'memberpoints'},
    {
      title: 'Quest status',
      titleBgColor: '#1976D2',
      titleColor: 'white', name: 'quest.status'}
  ];
  return columnsPlayers;
}
export function getColumnsCustomReports(allCCList, allOperatorList, resultTypeList): Column[] {
  var newAllCCList = [];
  allCCList.filter(m => m.ID > 3).forEach(function (obj) {
    newAllCCList.push({ id: obj.ID, name: obj.Name });
  });
  var newAllOperatorList = [];
  allOperatorList.filter(m => m.ID > 3).forEach(function (obj) {
    newAllOperatorList.push({ id: obj.ID, name: obj.Name });
  });
  var newAllOthersOperatorList = [];
  allOperatorList.filter(m => m.ID <= 3 || m.ID == 9).forEach(function (obj) {
    newAllOthersOperatorList.push({ id: obj.ID, name: obj.Name });
  });
  var newResultTypeList = [];
  resultTypeList.forEach(function (obj) {
    newResultTypeList.push({ id: obj.ID, name: obj.DisplayName });
  });
  const columnsCustomReports: Column[] = [
    //{
    //  title: 'Column Id',
    //  name: 'ColumnID',
    //  sortable: true,
    //  filter: true,
    //  frozen: false,
    //  width: 100,
    //  formHidden: true,
    //  type: 'number',
    //}, {
    //  title: 'Id',
    //  name: 'ID',
    //  sortable: true,
    //  filter: true,
    //  frozen: false,
    //  width: 100,
    //  formHidden: true,
    //  type: 'number',
    //},

    {
      title: 'Column Name',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'ColumnName',
      sortable: true,
      filter: true,
      frozen: false,
      width: 200,
      //validatorFunc: Validators.get({ required: true, minLength: 2, pattern: '^[a-zA-Z ]+$' }),
    }, {
      title: 'Result Type',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'ResultType',
      sortable: true,
      filter: true,
      type: 'select',
      options: newResultTypeList,//https://stackoverflow.com/questions/19590865/from-an-array-of-objects-extract-value-of-a-property-as-array
      //validatorFunc: Validators.get({ required: true }),
    },


    {
      title: 'Criteria Condition',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CriteriaCondition',
      sortable: true,
      filter: true,
      type: 'select',
      options: newAllCCList,
      //validatorFunc: Validators.get({ required: true }),
    }, 


    {
      title: 'Call Condition Operator',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CCEventConditionOperator',
      sortable: true,
      filter: true,
      type: 'select',
      options: newAllOperatorList,
      //validatorFunc: Validators.get({ required: true }),
    }, {
      title: 'Remove Characters from Forward and/or Backward',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'SearchMethod',
      sortable: true,
      filter: true,
      type: 'select',
      options: [
        { id: 'F', name: 'Forward' },
        { id: 'B', name: 'Backward' },
      ],
      //validatorFunc: Validators.get({ required: true }),
    }, {
      title: 'Number of Chars to be removed',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'RemoveCharCount',
      sortable: true,
      filter: true,
      frozen: false,//Moves the frozen colums to very left
      width: 100,
      formHidden: true,
      type: 'number',
    }, {
      title: 'Call Event Condition',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CCEventConditionInput',
      sortable: true,
      filter: true,
      frozen: false,
      width: 200,
      //validatorFunc: Validators.get({ required: true, minLength: 2, pattern: '^[a-zA-Z ]+$' }),
    }, {
      title: 'Call Event Operator',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CCEventOperator',
      sortable: true,
      filter: true,
      type: 'select',
      options: newAllOperatorList,
      //validatorFunc: Validators.get({ required: true }),
    }, {
      title: 'Call Control Event',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CCEventInput',
      sortable: true,
      filter: true,
      frozen: false,
      width: 200,
      //validatorFunc: Validators.get({ required: true, minLength: 2, pattern: '^[a-zA-Z ]+$' }),
    }, {
      title: 'Call Parameter(s) to be displayed',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CallEventsDisplayParameter',
      sortable: true,
      filter: true,
      type: 'select',
      options: [
        { id: '0', name: 'Call Control Event' },
        { id: '1', name: 'Call Event Condition' },
        { id: '2', name: 'Both' },],
      //validatorFunc: Validators.get({ required: true }),
    },


    {
      title: 'Input Operator',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Operator',
      sortable: true,
      filter: true,
      type: 'select',
      options: newAllOthersOperatorList,
      //validatorFunc: Validators.get({ required: true }),
    }, {
      title: 'Input Value',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'CriteriaInput',
      sortable: true,
      filter: true,
      frozen: false,
      width: 200,
      //validatorFunc: Validators.get({ required: true, minLength: 2, pattern: '^[a-zA-Z ]+$' }),
    },


    {
      title: 'Hide Column in grid',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'HideColumn',
      type: 'checkbox',
      options: [
        { id: 1, name: 'Hide' }
      ]
    }
  ];
  return columnsCustomReports;
}
export function getColumnsCallEvents(): Column[] {
  const columnsCallEvents: Column[] = [
    {
      title: 'VQuad Timestamp',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'VQuad_Timestamp',
      sortable: true,
      filter: true,
      type: 'datetime-local',
    },
    {
      title: 'Call Timestamp',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Call_Timestamp',
      sortable: true,
      filter: true,
      type: 'datetime-local',
    },
    {
      title: 'VQuad Call ID',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'VQuad_Call_ID',
      sortable: true,
      filter: true,
    },
    {
      title: 'VQuad Device ID',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'VQuad_Device_ID',
      sortable: true,
      filter: true,
    },
    {
      title: 'Latitude',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Latitude',
      sortable: true,
      filter: true,
    },
    {
      title: 'Longitude',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Longitude',
      sortable: true,
      filter: true,
    },
    {
      title: 'Call Control Event',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Call_Control_Event',
      sortable: true,
      filter: true,
    },
    {
      title: 'Call Type Originating',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Call_Type_Originating',
      sortable: true,
      filter: true,
    },
    {
      title: 'Call Type Terminating',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Call_Type_Terminating',
      sortable: true,
      filter: true,
    },
    {
      title: 'Call Event Condition',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'Call_Event_Condition',
      sortable: true,
      filter: true,
    },    
    {
      title: 'VQuad Event ID',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'VQuad_Event_ID',
      sortable: true,
      filter: true,
    },    
  ];
  return columnsCallEvents;
}

export function mainAndSubHeaders(rsltType, selectedSubResults): any {
  //https://www.w3schools.com/js/tryit.asp?filename=tryjson_array_nested
  let columnsHeaders: any;
  switch (rsltType) {
    case "emu":
      columnsHeaders = {
        'LeftStartIndex': 0, 'LeftEndIndex': 7, 'RightStartIndex': 47, 'RightEndIndex': 51,
        'internal': [
          { 'HeaderName': 'Block1', 'StartIndex': 7, 'EndIndex': 17, 'BgColor': '#6D96D6', 'Color': 'white' },
          { 'HeaderName': 'Block2', 'StartIndex': 17, 'EndIndex': 27, 'BgColor': '#E9EBEC', 'Color': 'black' },
          { 'HeaderName': 'Block3', 'StartIndex': 27, 'EndIndex': 37, 'BgColor': '#6D96D6', 'Color': 'white' },
          { 'HeaderName': 'Block4', 'StartIndex': 37, 'EndIndex': 47, 'BgColor': '#E9EBEC', 'Color': 'black' }
        ]
      };
      break;
    case "nettest":
      let myInternal = [];

      let Diff = 0;
      if (selectedSubResults.indexOf('TCPDATA') == -1)
        Diff += 45;
      else
        myInternal.push({ 'HeaderName': 'TCP', 'StartIndex': 18, 'EndIndex': 63, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('UDPDATA') == -1)
        Diff += 8;
      else
        myInternal.push({ 'HeaderName': 'UDP', 'StartIndex': 63 - Diff, 'EndIndex': 71 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('VOIPDATA') == -1)
        Diff += 13;
      else
        myInternal.push({ 'HeaderName': 'VOIP', 'StartIndex': 71 - Diff, 'EndIndex': 84 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('ROUTEDATA') == -1)
        Diff += 8;
      else
        myInternal.push({ 'HeaderName': 'ROUTE', 'StartIndex': 84 - Diff, 'EndIndex': 92 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('HTTPDATA') == -1)
        Diff += 18;
      else
        myInternal.push({ 'HeaderName': 'HTTP', 'StartIndex': 92 - Diff, 'EndIndex': 110 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('FTPDATA') == -1)
        Diff += 10;
      else
        myInternal.push({ 'HeaderName': 'FTP', 'StartIndex': 110 - Diff, 'EndIndex': 120 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('DNSDATA') == -1)
        Diff += 6;
      else
        myInternal.push({ 'HeaderName': 'DNS', 'StartIndex': 120 - Diff, 'EndIndex': 126 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('SMSDATA') == -1)
        Diff += 9;
      else
        myInternal.push({ 'HeaderName': 'SMS', 'StartIndex': 126 - Diff, 'EndIndex': 135 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('EMAILDATA') == -1)
        Diff += 9;
      else
        myInternal.push({ 'HeaderName': 'EMAIL', 'StartIndex': 135 - Diff, 'EndIndex': 144 - Diff, 'BgColor': '#969696', 'Color': 'white' });

      columnsHeaders = {
        'LeftStartIndex': 0, 'LeftEndIndex': 18, 'RightStartIndex': 144 - Diff, 'RightEndIndex': 147 - Diff,
        'internal': myInternal
      };
      break;
    case "mobileinfo":
      let myMobInternal = [];

      let mobDiff = 0;
      if (selectedSubResults.indexOf('GENERALINFO') == -1)
        mobDiff += 4;
      else
        myMobInternal.push({ 'HeaderName': 'PHONEINFO', 'StartIndex': 18, 'EndIndex': 22, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('SIMINFO') == -1)
        mobDiff += 3;
      else
        myMobInternal.push({ 'HeaderName': 'SIM', 'StartIndex': 22 - mobDiff, 'EndIndex': 25 - mobDiff, 'BgColor': '#969696', 'Color': 'white' });

      if (selectedSubResults.indexOf('UEINFO') == -1)
        mobDiff += 8;
      else
        myMobInternal.push({ 'HeaderName': 'UE', 'StartIndex': 25 - mobDiff, 'EndIndex': 33 - mobDiff, 'BgColor': '#969696', 'Color': 'white' });

      columnsHeaders = {
        'LeftStartIndex': 0, 'LeftEndIndex': 18, 'RightStartIndex': 33 - mobDiff, 'RightEndIndex': 36 - mobDiff,
        'internal': myMobInternal
      };
      break;
    case "vac":
      columnsHeaders = {
        //'LeftStartIndex': 0, 'LeftEndIndex': 13, 'RightStartIndex': 43, 'RightEndIndex': 46,
        'LeftStartIndex': 0, 'LeftEndIndex': 13, 'RightStartIndex': 41, 'RightEndIndex': 44,
        'internal': [
          { 'HeaderName': '', 'StartIndex': 13, 'EndIndex': 16, 'BgColor': '#6D96D6', 'Color': 'white' },
          { 'HeaderName': 'VIDEO QUALITY', 'StartIndex': 16, 'EndIndex': 23, 'BgColor': '#E9EBEC', 'Color': 'black' },
          //{ 'HeaderName': 'AUDIO QUALITY', 'StartIndex': 23, 'EndIndex': 28, 'BgColor': '#6D96D6', 'Color': 'white' },
          //{ 'HeaderName': 'AUDIO-VIDEO QUALITY', 'StartIndex': 28, 'EndIndex': 30, 'BgColor': '#E9EBEC', 'Color': 'black' },
          //{ 'HeaderName': 'IP NETWORK HEALTH', 'StartIndex': 30, 'EndIndex': 37, 'BgColor': '#6D96D6', 'Color': 'white' },
          //{ 'HeaderName': 'CALL CONFIG INFO', 'StartIndex': 37, 'EndIndex': 43, 'BgColor': '#E9EBEC', 'Color': 'black' }
          { 'HeaderName': 'AUDIO QUALITY', 'StartIndex': 23, 'EndIndex': 27, 'BgColor': '#6D96D6', 'Color': 'white' },
          { 'HeaderName': 'AUDIO-VIDEO QUALITY', 'StartIndex': 27, 'EndIndex': 28, 'BgColor': '#E9EBEC', 'Color': 'black' },
          { 'HeaderName': 'IP NETWORK HEALTH', 'StartIndex': 28, 'EndIndex': 35, 'BgColor': '#6D96D6', 'Color': 'white' },
          { 'HeaderName': 'CALL CONFIG INFO', 'StartIndex': 35, 'EndIndex': 41, 'BgColor': '#E9EBEC', 'Color': 'black' }
        ]
      };
      break;
  }
  //console.log(columnsHeaders)
  return columnsHeaders;
}
export function getColumnsHeaders(rsltType: string, selectedSubResults: any, DAQOrNot?: boolean): Column[] {

  let columnsHeaders: Column[] = [];
  switch (rsltType) {
    case "pesq":
    case "pesq_config":
    case "pesq_advFilter":
      columnsHeaders = headersNTypes(new VQTPESQDATA(), rsltType, DAQOrNot);
      break;
    case "polqa":
      columnsHeaders = headersNTypes(new VQTPOLQADATA(), rsltType);
      break;
    case "call-events":
      columnsHeaders = headersNTypes(new VQUADDATA(), rsltType);
      break;
    case "vba":
      columnsHeaders = headersNTypes(new EModule(), rsltType);
      break;
    case "fax":
      columnsHeaders = headersNTypes(new FAXDATA(), rsltType);
      break;
    case "audio-delay":
      columnsHeaders = headersNTypes(new AUDIODELAYDATA(), rsltType);
      break;
    case "emu":
      columnsHeaders = headersNTypes(new EMUDATA(), rsltType);
      break;
    case "nettest":
      //https://stackoverflow.com/questions/49937677/how-to-merge-class-instances-in-typescript
      //https://stackoverflow.com/questions/47670959/typescript-declaration-merge-a-class-and-an-interface
      //https://stackoverflow.com/questions/37042602/how-to-combine-object-properties-in-typescript
      //https://alligator.io/js/dealing-with-objects/
      let xy = null;
      //https://www.tutorialspoint.com/typescript/typescript_array_indexof.htm
      if (selectedSubResults.indexOf('EMAILDATA') != -1) {
        xy = Object.assign(
          new EMAILDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('SMSDATA') != -1) {
        xy = Object.assign(
          new SMSDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('DNSDATA') != -1) {
        xy = Object.assign(
          new DNSDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('FTPDATA') != -1) {
        xy = Object.assign(
          new FTPDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('HTTPDATA') != -1) {
        xy = Object.assign(
          new HTTPDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('ROUTEDATA') != -1) {
        xy = Object.assign(
          new ROUTEDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('VOIPDATA') != -1) {
        xy = Object.assign(
          new VOIPDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('UDPDATA') != -1) {
        xy = Object.assign(
          new UDPDATA(),
          xy
        );
      }
      if (selectedSubResults.indexOf('TCPDATA') != -1) {
        xy = Object.assign(
          new TCPDATA(),
          xy
        );
      }

      
      columnsHeaders = headersNTypes(xy, rsltType);

      //https://stackoverflow.com/questions/44661490/understanding-findindex-in-javascript-typescript
      //https://riptutorial.com/typescript/example/29544/finding-object-in-array
      let endCols: any[] = ['CallType_Orig', 'CallType_Term', 'VQuad_CallID'];
      for (let xy in endCols) {
        const position = columnsHeaders.findIndex((quoteEl: Column) => {
          return quoteEl.name == endCols[xy];
        });

        //https://stackoverflow.com/questions/24909371/move-item-in-object-to-last-position
        //https://love2dev.com/blog/javascript-remove-from-array/
        columnsHeaders.push(columnsHeaders.splice(position, 1)[0]);
      }
      break;
    case "mobileinfo":
      let mob = null;
      //https://www.tutorialspoint.com/typescript/typescript_array_indexof.htm
      if (selectedSubResults.indexOf('UEINFO') != -1) {
        mob = Object.assign(
          new UEINFO(),
          mob
        );
      }
      if (selectedSubResults.indexOf('SIMINFO') != -1) {
        mob = Object.assign(
          new SIMINFO(),
          mob
        );
      }
      if (selectedSubResults.indexOf('GENERALINFO') != -1) {
        mob = Object.assign(
          new GENERALINFO(),
          mob
        );
      }


      columnsHeaders = headersNTypes(mob, rsltType);

      let mobEndCols = ['CallType_Orig', 'CallType_Term', 'VQuad_CallID'];
      for (let eachCol in mobEndCols) {
        const position = columnsHeaders.findIndex((quoteEl: Column) => {
          return quoteEl.name == mobEndCols[eachCol];
        });

        columnsHeaders.push(columnsHeaders.splice(position, 1)[0]);
      }
      break;
    case "vac":
      columnsHeaders = headersNTypes(new VACDATA(), rsltType);
      break;
  }

  return columnsHeaders;
}
export function getConfigColumnsHeaders(rsltType: string): Column[] {

  let columnsHeaders: Column[] = [];
  switch (rsltType) {
    case "gmaps-config":
      columnsHeaders = headersNTypes(new GMaps(), rsltType);
      break;
    case "filters":
      columnsHeaders = headersNTypes(new Filters(), rsltType);
      break;
  }

  return columnsHeaders;
}

export function getColumnsRank(): Column[] {
  const columnsRank: Column[] = [
    {title: 'player_id', titleBgColor: '#1976D2',titleColor: 'white', name: 'player_id', width: 100},
    {title: 'daily_ap', titleBgColor: '#1976D2',titleColor: 'white', name: 'daily_ap', width: 100},
    {title: 'weekly_ap', titleBgColor: '#1976D2',titleColor: 'white', name: 'weekly_ap', width: 100},
    {title: 'ap', titleBgColor: '#1976D2',titleColor: 'white', name: 'ap', width: 100},
    {title: 'rank', titleBgColor: '#1976D2',titleColor: 'white', name: 'rank', width: 100},
    {title: 'top_ranking', titleBgColor: '#1976D2',titleColor: 'white', name: 'top_ranking', width: 100},
    {title: 'old_ranking', titleBgColor: '#1976D2',titleColor: 'white', name: 'old_ranking', width: 100},
    {title: 'daily_kill', titleBgColor: '#1976D2',titleColor: 'white', name: 'old_ranking', width: 100},
    {title: 'weekly_kill', titleBgColor: '#1976D2',titleColor: 'white', name: 'weekly_kill', width: 100},
    {title: 'all_kill', titleBgColor: '#1976D2',titleColor: 'white', name: 'all_kill', width: 100},
    {title: 'max_rank', titleBgColor: '#1976D2',titleColor: 'white', name: 'max_rank', width: 100},
    {title: 'last_kill', titleBgColor: '#1976D2',titleColor: 'white', name: 'last_kill', width: 100},
    {title: 'last_ap', titleBgColor: '#1976D2',titleColor: 'white', name: 'last_ap', width: 100},
    {title: 'last_update', titleBgColor: '#1976D2',titleColor: 'white', name: 'last_update', width: 120}
  ];
  return columnsRank;
}

export function getColumnsInventory(): Column[] {
  const columnsInventory: Column[] = [
    {title: 'itemUniqueId', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemUniqueId', width: 100},
    {title: 'itemId', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemId', width: 100},
    {title: 'itemCount', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemCount', width: 100},
    {title: 'itemColor', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemColor', width: 100},
    {title: 'itemOwner', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemOwner', width: 100},
    {title: 'itemCreationTime', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemCreationTime'},
    {title: 'itemExistTime', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemExistTime'},
    {title: 'itemTradeTime', titleBgColor: '#1976D2',titleColor: 'white', name: 'itemTradeTime'},
    {title: 'isEquiped', titleBgColor: '#1976D2',titleColor: 'white', name: 'isEquiped'},
    {title: 'isSoulBound', titleBgColor: '#1976D2',titleColor: 'white', name: 'isSoulBound'},
    {title: 'slot', titleBgColor: '#1976D2',titleColor: 'white', name: 'slot'},
    {title: 'sealEndTime', titleBgColor: '#1976D2',titleColor: 'white', name: 'sealEndTime'}
  ];
  return columnsInventory;
}

export function getTreeColumns(): Column[] {
  return [
    {
      title: 'Node',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'node',
      frozen: true,
      width: 250,
    },
    {
      title: 'Name',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'name',
      editable: true,
      validatorFunc: Validators.get({required: true, minLength: 2, pattern: '^[a-zA-Z ]+$'}),
      width: 250,
    },
    {
      title: 'Gender',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'gender',
      editable: true,
      type: 'radio',
      options: [
        {id: 'MALE', name: 'MALE'},
        {id: 'FEMALE', name: 'FEMALE'},
      ],
      width: 250,
    },
    {
      title: 'Cube_size',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'cube_size',
      editable: true,
      width: 250,
      type: 'number',
    },
    {
      title: 'Exp',
      titleBgColor: '#1976D2',
      titleColor: 'white',
      name: 'exp',
      editable: true,
      width: 250,
    }
  ];
}
